import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { actions } from '../redux/brokerActions';
import BrokerCommissionForm from '../components/BrokerCommissionForm/BrokerCommissionForm';
import { BackButton, Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';

import BrokerAdminFeeForm from '../components/BrokerAdminFeeForm/BrokerAdminFeeForm';

import { getActiveCommissions, getAvailableProducts } from '../helpers';

const BrokerCommissionContainer = ({
  params: { id },
  getBroker,
  updateBroker,
  broker,
  user,
}) => {
  useEffect(
    () => {
      getBroker(id);
    },
    [id, getBroker],
  );

  const resource = broker?.resources[id];

  const activeCommissions = useMemo(() => getActiveCommissions(resource), [resource]);

  const availableProducts = useMemo(() => getAvailableProducts(user), [user]);

  if (!resource?.data) {
    return (
      <InternalContainer title="Broker Commissions" buttons={<BackButton />}>
        <Loader />
      </InternalContainer>
    );
  }

  const isTrackingLink = ['introducer', 'tracking'].includes(
    resource?.data.attributes.broker_type,
  );

  const update = (broker) => {
    return Promise.resolve(updateBroker(broker, id, isTrackingLink)).then(() => {
      getBroker(id);
    });
  };

  return (
    <InternalContainer title="Broker Commissions" buttons={<BackButton />}>
      <>
        <BrokerCommissionForm
          resource={resource}
          availableProducts={availableProducts}
          activeCommissions={activeCommissions}
          isTracking={isTrackingLink}
          onUpdateCommission={update}
          insurers={resource?.meta ?? []}
        />
        <BrokerAdminFeeForm
          resource={resource}
          isTracking={isTrackingLink}
          onUpdateFee={update}
        />
      </>
    </InternalContainer>
  );
};

export default connect(
  (state) => ({
    broker: state.broker,
    user: state.auth.user,
  }),
  {
    getBroker: actions.getBroker,
    updateBroker: actions.updateBroker,
  },
)(BrokerCommissionContainer);
